import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useParams } from "react-router-dom"
import { HiClipboardDocumentList } from 'react-icons/hi2'
import { FaUsers } from 'react-icons/fa'
import { HiArchive } from 'react-icons/hi'
import Alert from 'react-bootstrap/Alert'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { apiURL, filesURL } from 'config/globals'
import Topbar from 'components/Topbar'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const MuseumDashboard = () => {
    const [currentUser, setCurrentUser] = useState()
    const [museum, setMuseum] = useState({})
    const [loadError, setLoadError] = useState('')
    const navigate = useNavigate()
    const { entityId } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            await getMuseum(entityId)
        }
        start()
    }, [])

    const getMuseum = async (id) => {
        try {
            const response = await axios.get(`${apiURL}/get-museum/${id}`)

            if (!response.data.success) {
                setLoadError("Cannot load museum data: " + (response.data.error || response.data))
                return
            }

            setMuseum(response.data.item)
        } catch (error) {
            setLoadError(JSON.stringify(error))
        }
    }

    const jumpToArchive = () => {
        navigate(`/museum/${entityId}/archive`)
    }

    const jumpToDocumentation = () => {
        navigate(`/museum/${entityId}/documentation`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <main className="full-width">
                {museum.id &&
                    <>
                        <div style={{margin: '-24px'}}>
                            <div className="mb-4" style={{overflow: 'hidden', height: '200px', display: 'flex', alignItems: 'center'}}>
                                <img src={`${filesURL}/${museum.mainImage}`} style={{width: '100%'}}/>
                            </div>
                        </div>
                        <header className="mt-4">
                            <div className="float-start">
                                <h1>{museum.name}</h1>
                                <h5 className="mt-5">Welcome back, {currentUser.name}!</h5>
                            </div>
                        </header>
                        <Row>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem mb-4" onClick={jumpToArchive}>
                                    <Card.Body>
                                        <div className="navIcon"><HiArchive /></div>
                                        <Card.Title>Museum<br/>Archive</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem mb-4" onClick={jumpToDocumentation}>
                                    <Card.Body>
                                        <div className="navIcon"><HiClipboardDocumentList /></div>
                                        <Card.Title>Documentation<br/>Workspace</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm="6" md="4" lg="3" key="">
                                <Card className="navItem disabled mb-4">
                                    <Card.Body>
                                        <div className="navIcon"><FaUsers /></div>
                                        <Card.Title>Staff<br/>Workspace</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                }
                {loadError &&
                    <>
                        <Alert key='loadError' variant='danger'>
                            {loadError}
                        </Alert>
                    </>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default MuseumDashboard